import LnerTrainIcon from './LnerTrainIcon';

export default LnerTrainIcon;